var _excluded = ["children"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { useEffect } from 'react';
/* 
  This context must be imported using the client-site-chrome-ui alias  
  i.e. client-site-chrome-ui/context/DynamicContext/context
  to ensure it is always resolved from the same location by yarn PNP
  otherwise an error can be thrown that the context is not defined 
  i.e.'useSiteChromeDynamicContext must be used within a SiteChromeDynamicContextProvider'
*/
import { SiteChromeDynamicContext } from "./SiteChromeDynamicContext";
import { useSiteChromeStaticContext } from "../SiteChromeStaticContext/useSiteChromeStaticContext";
import { useContentOverlay } from "../../hooks/useContentOverlay";
import { useDepartmentsNavigation } from "../../hooks/useDepartmentsNavigation";
import { useLocale } from "../../hooks/useLocale/useLocale";
import { useLocaleModal } from "../../hooks/useLocaleModal/useLocaleModal";
import { useNavigationModal } from "../../hooks/useNavigationModal/useNavigationModal";
export var SiteChromeDynamicContextProvider = function SiteChromeDynamicContextProvider(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useSiteChromeStaticC = useSiteChromeStaticContext(),
    cookies = _useSiteChromeStaticC.cookies;
  var departmentsNavigation = useDepartmentsNavigation();
  var contentOverlay = useContentOverlay();
  var localeModal = useLocaleModal();
  var navigationModal = useNavigationModal();
  var contextValue = {
    navigationModal,
    contentOverlay,
    departmentsNavigation,
    locale: useLocale({
      cookies
    }),
    localeModal
  };
  useEffect(function () {
    if (localeModal.isOpen) {
      if (navigationModal.isOpen) {
        navigationModal.closeWithoutTracking();
      }
      contentOverlay.open(0);
    } else {
      contentOverlay.close();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [localeModal.isOpen]);
  return /*#__PURE__*/React.createElement(SiteChromeDynamicContext.Provider, _extends({
    value: contextValue
  }, props), children);
};